import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";
import { Loader } from "../common";
import {
  resetReport,
  fetchReports,
  getFeeAccounts,
  fetchStudentsData,
  getSalesReport,
  getReceiptsReport,
} from "../../actions";
import ReactExport from "react-export-excel";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import moment from "moment";
import feeAccounts from "../feeBundle/feeAccounts";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: 200,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && "#3994AE",
  }),
};

const PAYMENT_TYPES = {
  CHEQUE: 1,
  DD: 2,
  ONLINE_TRANSFER: 5,
  CARD: 7,
  CASH_DEPOSIT: 9,
};

const selected = {
  borderBottom: `3px solid ${StyleConstants.color.darkBlue}`,
  color: StyleConstants.color.darkBlue,
  fontSize: 20,
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};
const unselected = {
  fontSize: 20,
  color: "#c4c4c4",
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};

class Tool extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedFeeAccounts: this.props.feeAccounts,
      startDate: undefined,
      endDate: undefined,
      selectedAccountant: null,
      selectedPaymentTypes: Object.keys(PAYMENT_TYPES).map((mode) => {
        return { value: PAYMENT_TYPES[mode], label: mode };
      }),
      selectedCampus: null,
      hasAccess: true,
      showDaywiseReport: false,
      payments: [],
      selectedInstitutesTrack: null,
      showStudentDetails: true,
      selectedClassroom: null,
      pageForStudentLedger: 1,
      pageForSales: 1,
      pageForReciepts: 1,
      perPage: 10,
      selectedFeeAccounts: [],
    };
  }
  async componentDidMount() {
    await this.props.fetchStudentsData();
  }

  renderMultipleSelect(options, selectedOptions, placeholder, key) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: 5,
        }}
      >
        <div style={{ marginRight: "auto", fontSize: 14 }}>{placeholder}:</div>
        <Select
          value={selectedOptions}
          onChange={(options) => this.setState({ [key]: options })}
          options={options}
          placeholder={placeholder}
          styles={customDropdownStyles}
          isSearchable
          isClearable
          isMulti
        />
      </div>
    );
  }

  renderSingleSelect(options, selectedOption, key, placeholder) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: 5,
        }}
      >
        <div style={{ marginRight: "auto", fontSize: 14 }}>{placeholder}:</div>
        <Select
          value={selectedOption}
          onChange={(option) => this.setState({ [key]: option })}
          options={options}
          placeholder={placeholder}
          styles={customDropdownStyles}
          isSearchable
          isClearable
        />
      </div>
    );
  }

  renderInputs() {
    const { feeAccounts } = this.props;
    const { startDate, endDate, selectedFeeAccounts, showDaywiseReport } =
      this.state;
    return (
      <div
        style={{
          flex: 1,
          padding: 15,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid gray",
          fontFamily: "'Poppins', sans-serif",
          color: StyleConstants.color.darkBlue,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginRight: 10 }}>Select Account:</div>
          {this.renderMultipleSelect(feeAccounts, selectedFeeAccounts)}
        </div>
        <div style={{ display: "flex", alignItems: "center", marginLeft: 20 }}>
          <div style={{ marginRight: 10 }}>Start Date:</div>
          <input
            type="date"
            value={startDate}
            onChange={(event) =>
              this.setState({ startDate: event.target.value })
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginLeft: 20 }}>
          <div style={{ marginRight: 10 }}>End Date:</div>
          <input
            type="date"
            value={endDate}
            onChange={(event) => this.setState({ endDate: event.target.value })}
          />
        </div>
        <div
          className="Button Primary-Button"
          style={{ marginLeft: 20, width: 100 }}
          onClick={async () => {
            await this.props.fetchReports(
              selectedFeeAccounts.map((account) => account.id),
              startDate,
              endDate,
              showDaywiseReport
            );
            this.setState({
              payments: this.props.payments.map((payment) => {
                return {
                  ...payment,
                  isActive: true,
                  narration: `Being Amount is paid by ${payment.payment_type}`,
                };
              }),
            });
          }}
        >
          Fetch
        </div>
      </div>
    );
  }

  renderFilters() {
    const {
      selectedPaymentTypes,
      selectedCampus,
      selectedClassroom,
      showStudentDetails,
      showReceiptReport,
      selectedFeeAccounts,
      startDate,
      endDate,
      showSalesReport,
    } = this.state;
    const { campuses, classrooms, feeAccounts } = this.props;
    return (
      <div>
        <div
          style={{
            flex: 1,
            display: "flex",
            margin: "20px 0px",
            justifyContent: "center",
            fontFamily: "'Poppins', sans-serif",
            color: StyleConstants.color.darkBlue,
          }}
        >
          {campuses.length > 1 &&
            this.renderSingleSelect(
              campuses,
              selectedCampus,
              "selectedCampus",
              "Select Campus"
            )}

          {classrooms.length > 1 &&
            this.renderSingleSelect(
              classrooms,
              selectedClassroom,
              "selectedClassroom",
              "Select Classroom"
            )}

          {(showReceiptReport || showSalesReport) &&
            this.renderMultipleSelect(
              Object.keys(PAYMENT_TYPES).map((mode) => {
                return { value: PAYMENT_TYPES[mode], label: mode };
              }),
              selectedPaymentTypes,
              "Select Payment Type",
              "selectedPaymentTypes"
            )}
          {(showReceiptReport || showSalesReport) &&
            feeAccounts.length > 0 &&
            this.renderMultipleSelect(
              feeAccounts,
              selectedFeeAccounts,
              "Select Accounts",
              "selectedFeeAccounts"
            )}
        </div>
        {(showReceiptReport || showSalesReport) && (
          <div
            key={startDate}
            style={{
              flex: 1,
              display: "flex",
              margin: "20px 0px",
              justifyContent: "center",
              fontFamily: "'Poppins', sans-serif",
              color: StyleConstants.color.darkBlue,
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", marginLeft: 20 }}
            >
              <div style={{ marginRight: 10 }}>Start Date:</div>
              <input
                type="date"
                value={startDate}
                onChange={(event) =>
                  this.setState({ startDate: event.target.value })
                }
              />
            </div>
            <div
              style={{ display: "flex", alignItems: "center", marginLeft: 20 }}
            >
              <div style={{ marginRight: 10 }}>End Date:</div>
              <input
                type="date"
                value={endDate}
                onChange={(event) =>
                  this.setState({ endDate: event.target.value })
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderTabs() {
    const { showStudentDetails, showReceiptReport, showSalesReport } =
      this.state;
    const { salesReport, receiptsReport } = this.props;
    return (
      <div
        style={{
          display: "flex",
          width: "80%",
          marginBottom: 10,
        }}
      >
        <div
          style={showStudentDetails ? selected : unselected}
          onClick={() => {
            this.setState({
              showStudentDetails: true,
              showReceiptReport: false,
              showSalesReport: false,
              selectedClassroom: null,
              selectedCampus: null,
            });
            window.scrollTo(0, 0);
          }}
        >
          Ledger Masters
        </div>
        <div
          style={showSalesReport ? selected : unselected}
          onClick={() => {
            this.setState({
              showSalesReport: true,
              showStudentDetails: false,
              showReceiptReport: false,
              selectedClassroom: null,
              selectedCampus: null,
              startDate: null,
              endDate: null,
            });
            salesReport.length === 0 && this.props.getSalesReport();
            window.scrollTo(0, 0);
          }}
        >
          Billing
        </div>
        <div
          style={showReceiptReport ? selected : unselected}
          onClick={() => {
            this.setState({
              showReceiptReport: true,
              showStudentDetails: false,
              showSalesReport: false,
              selectedClassroom: null,
              selectedCampus: null,
              startDate: null,
              endDate: null,
            });
            receiptsReport.length === 0 && this.props.getReceiptsReport();
            window.scrollTo(0, 0);
          }}
        >
          Receipt
        </div>
      </div>
    );
  }

  renderStudentLedger() {
    const { selectedCampus, selectedClassroom, pageForStudentLedger, perPage } =
      this.state;
    const { students } = this.props;
    let filteredStudents = students.map((student) => {
      return {
        ...student,
        group: "Sundry Debtors",
        ledger_name: `${student.first_name}`,
      };
    });
    if (selectedCampus) {
      filteredStudents = filteredStudents.filter(
        (student) => student.campus_id === selectedCampus.value
      );
    }
    if (selectedClassroom) {
      filteredStudents = filteredStudents.filter(
        (student) => student.classroom_id === selectedClassroom.value
      );
    }
    return (
      <div
        style={{
          display: "block",
          justifyContent: "center",
          overflowX: "auto",
        }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 1px 2px 6px #8b9daf26;
          }
          th {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-weight: normal;
            font-size: 14px;
          }
          td {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
          }
          thead {
            background-color: #edf1f8;
            color: ${StyleConstants.color.darkBlue};
          }
          tbody {
            color: gray;
          }
        `}
        </style>
        <div
          style={{
            width: "100%",
            margin: 15,
            display: "flex",
            borderRadius: 4,
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {!filteredStudents?.length ? (
            <div
              style={{
                textAlign: "center",
                color: StyleConstants.color.darkBlue,
                fontFamily: "'Poppins', sans-serif",
                fontSize: 20,
                margin: 30,
              }}
            >
              No students present
            </div>
          ) : (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Ledger Name</th>
                    <th>Alias (ID)</th>
                    <th>Group</th>
                    <th>Mailing Name</th>
                    <th>Address 1</th>
                    <th>Address 2</th>
                    <th>Address 3</th>
                    <th>Address 4</th>
                    <th>Address 5</th>
                    <th>Country</th>
                    <th>State</th>
                    <th>Pin Code</th>
                    <th>Contact Person</th>
                    <th>Phone</th>
                    <th>Mobile No.</th>
                    <th>FAX</th>
                    <th>Email Id</th>
                    <th>Maintian bill by bill</th>
                    <th>Credit Period</th>
                    <th>Is Costcentre applicable</th>
                    <th>PAN/ IT No.</th>
                    <th>GSTIN/UIN No.</th>
                    <th>Amount</th>
                    <th>Type (Dr/Cr)</th>
                  </tr>
                </thead>
                <tbody style={{ padding: 20 }}>
                  {filteredStudents
                    .slice(
                      (pageForStudentLedger - 1) * perPage,
                      pageForStudentLedger * perPage
                    )
                    .map((student) => {
                      return (
                        <tr key={student.badge_id}>
                          <td>{student.ledger_name}</td>
                          <td>{student.badge_id}</td>
                          <td>{student.group}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{student.phone}</td>
                          <td></td>
                          <td></td>
                          <td>{student.email}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                activePage={pageForStudentLedger}
                itemsCountPerPage={perPage}
                totalItemsCount={filteredStudents.length}
                pageRangeDisplayed={6}
                onChange={(pageNumber) =>
                  this.setState({ pageForStudentLedger: pageNumber })
                }
              />
            </div>
          )}
          <div style={{ paddingTop: "25px", paddingLeft: "950px" }}>
            {this.renderDownloadStudentLedger(filteredStudents)}
          </div>
        </div>
      </div>
    );
  }

  renderSalesReport() {
    const { salesReport } = this.props;
    const {
      pageForSales,
      perPage,
      selectedCampus,
      selectedClassroom,
      startDate,
      endDate,
      selectedFeeAccounts,
      selectedPaymentTypes,
    } = this.state;
    let filteredSalesReport = salesReport;
    const paymentTypes = Object.values(selectedPaymentTypes).map(
      (payment) => payment.value
    );
    filteredSalesReport = filteredSalesReport.filter((report) => {
      return paymentTypes.includes(report.payment_type);
    });
    if (selectedFeeAccounts.length != 0) {
      const feeAccounts = Object.values(selectedFeeAccounts).map(
        (account) => account.value
      );
      filteredSalesReport = filteredSalesReport.filter((student) => {
        return feeAccounts.includes(student.fee_account_id);
      });
    }
    if (selectedCampus) {
      filteredSalesReport = filteredSalesReport.filter(
        (student) => student.campus_id === selectedCampus.value
      );
    }
    if (selectedClassroom) {
      filteredSalesReport = filteredSalesReport.filter(
        (student) => student.classroom_id === selectedClassroom.value
      );
    }
    if (startDate && endDate) {
      filteredSalesReport = filteredSalesReport.filter((student) => {
        return (
          moment(student.bill_date).isSameOrAfter(startDate) &&
          moment(student.bill_date).isBefore(endDate)
        );
      });
    }
    return (
      <div
        style={{
          display: "block",
          justifyContent: "center",
          overflowX: "auto",
        }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 1px 2px 6px #8b9daf26;
          }
          th {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-weight: normal;
            font-size: 14px;
          }
          td {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
          }
          thead {
            background-color: #edf1f8;
            color: ${StyleConstants.color.darkBlue};
          }
          tbody {
            color: gray;
          }
        `}
        </style>
        <div
          style={{
            width: "100%",
            margin: 15,
            display: "flex",
            borderRadius: 4,
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {!filteredSalesReport?.length ? (
            <div
              style={{
                textAlign: "center",
                color: StyleConstants.color.darkBlue,
                fontFamily: "'Poppins', sans-serif",
                fontSize: 20,
                margin: 30,
              }}
            >
              No data present
            </div>
          ) : (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>ID/ Vch No.</th>
                    <th>Vch Type</th>
                    <th>Date</th>
                    <th>Reference</th>
                    <th>Debit Ledger</th>
                    <th>Credit Ledger</th>
                    <th>Amount</th>
                    <th>Billname</th>
                    <th>Narration</th>
                  </tr>
                </thead>
                <tbody style={{ padding: 20 }}>
                  {filteredSalesReport
                    .slice((pageForSales - 1) * perPage, pageForSales * perPage)
                    .map((report, index) => {
                      return (
                        <tr key={index}>
                          <td>{report.vch_no}</td>
                          <td>{report.vch_type}</td>
                          <td>{report.date}</td>
                          <td>{report.reference}</td>
                          <td>{report.debit_ledger}</td>
                          <td>{report.credit_ledger}</td>
                          <td>{report.amount}</td>
                          <td>{report.bill_name}</td>
                          <td>{report.narration}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                activePage={pageForSales}
                itemsCountPerPage={perPage}
                totalItemsCount={filteredSalesReport.length}
                pageRangeDisplayed={6}
                onChange={(pageNumber) =>
                  this.setState({ pageForSales: pageNumber })
                }
              />
            </div>
          )}
          <div style={{ paddingTop: "25px", paddingLeft: "950px" }}>
            {this.renderDownloadSalesReport(filteredSalesReport)}
          </div>
        </div>
      </div>
    );
  }

  renderReceiptsReport() {
    const { receiptsReport } = this.props;
    const {
      pageForReciepts,
      perPage,
      selectedPaymentTypes,
      selectedCampus,
      selectedClassroom,
      selectedFeeAccounts,
      endDate,
      startDate,
    } = this.state;
    const paymentTypes = Object.values(selectedPaymentTypes).map(
      (payment) => payment.label
    );
    let filteredReceiptsReport = receiptsReport.filter((report) => {
      return paymentTypes.includes(report.payment_type);
    });
    if (selectedCampus) {
      filteredReceiptsReport = filteredReceiptsReport.filter(
        (student) => student.campus_id === selectedCampus.value
      );
    }
    if (selectedClassroom) {
      filteredReceiptsReport = filteredReceiptsReport.filter(
        (student) => student.classroom_id === selectedClassroom.value
      );
    }
    if (selectedFeeAccounts.length != 0) {
      const feeAccounts = Object.values(selectedFeeAccounts).map(
        (account) => account.value
      );
      filteredReceiptsReport = filteredReceiptsReport.filter((student) => {
        return feeAccounts.includes(student.fee_account_id);
      });
    }
    if (startDate && endDate) {
      filteredReceiptsReport = filteredReceiptsReport.filter((student) => {
        return (
          moment(student.payment_date).isSameOrAfter(startDate) &&
          moment(student.payment_date).isBefore(endDate)
        );
      });
    }
    return (
      <div
        style={{
          display: "block",
          justifyContent: "center",
          overflowX: "auto",
        }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 1px 2px 6px #8b9daf26;
          }
          th {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-weight: normal;
            font-size: 14px;
          }
          td {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
          }
          thead {
            background-color: #edf1f8;
            color: ${StyleConstants.color.darkBlue};
          }
          tbody {
            color: gray;
          }
        `}
        </style>
        <div
          style={{
            width: "100%",
            margin: 15,
            display: "flex",
            borderRadius: 4,
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {!filteredReceiptsReport?.length ? (
            <div
              style={{
                textAlign: "center",
                color: StyleConstants.color.darkBlue,
                fontFamily: "'Poppins', sans-serif",
                fontSize: 20,
                margin: 30,
              }}
            >
              No data present
            </div>
          ) : (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Receipt Number</th>
                    <th>Date</th>
                    <th>LedgerName</th>
                    <th>Fee Head / Bill Name</th>
                    <th>Cash/Bank Name</th>
                    <th>Cheque No</th>
                    <th>Payee Bank Name</th>
                    <th>Amount</th>
                    <th>Narration</th>
                    <th>Voucher type</th>
                  </tr>
                </thead>
                <tbody style={{ padding: 20 }}>
                  {filteredReceiptsReport
                    .slice(
                      (pageForReciepts - 1) * perPage,
                      pageForReciepts * perPage
                    )
                    .map((report, index) => {
                      return (
                        <tr key={index}>
                          <td>{report.receipt_number}</td>
                          <td>{report.date}</td>
                          <td>{report.ledger_name}</td>
                          <td>{report.bill_name}</td>
                          <td>{report.bank_name}</td>
                          <td>{report.cheque_no}</td>
                          <td>{report.payee_bank_name}</td>
                          <td>{report.amount}</td>
                          <td>{report.narration}</td>
                          <td>{report.vch_type}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                activePage={pageForReciepts}
                itemsCountPerPage={perPage}
                totalItemsCount={filteredReceiptsReport.length}
                pageRangeDisplayed={6}
                onChange={(pageNumber) =>
                  this.setState({ pageForReciepts: pageNumber })
                }
              />
            </div>
          )}
          <div style={{ paddingTop: "25px", paddingLeft: "950px" }}>
            {this.renderDownloadReceiptsReport(filteredReceiptsReport)}
          </div>
        </div>
      </div>
    );
  }

  renderDownloadStudentLedger(dataset) {
    if (dataset.length === 0) {
      return;
    }
    return (
      <ExcelFile
        filename={`Ledger Master-${moment().format("DD-MM-YYYY")}`}
        element={
          <div
            className="Button Primary-Button"
            style={{
              marginLeft: 20,
              width: 100,
              fontFamily: "'Poppins', sans-serif",
              padding: "0 5px",
            }}
          >
            {" "}
            Download
          </div>
        }
      >
        <ExcelSheet data={dataset} name="ledger master">
          <ExcelColumn label="Ledger Name" value="ledger_name" />
          <ExcelColumn label="Alias (ID)" value="badge_id" />
          <ExcelColumn label="Group" value="group" />
          <ExcelColumn label="Mailing Name" value="" />
          <ExcelColumn label="Address 1" value="" />
          <ExcelColumn label="Address 2" value="" />
          <ExcelColumn label="Address 3" value="" />
          <ExcelColumn label="Address 4" value="" />
          <ExcelColumn label="Address 5" value="" />
          <ExcelColumn label="Country" value="" />
          <ExcelColumn label="State" value="" />
          <ExcelColumn label="Pin Code" value="" />
          <ExcelColumn label="Contact Person" value="" />
          <ExcelColumn label="Phone" value="phone" />
          <ExcelColumn label="Mobile No." value="" />
          <ExcelColumn label="FAX" value="" />
          <ExcelColumn label="Email Id" value="email" />
          <ExcelColumn label="Maintian bill by bill" value="" />
          <ExcelColumn label="Credit Period" value="" />
          <ExcelColumn label="Is Costcentre applicable" value="" />
          <ExcelColumn label="PAN/ IT No." value="" />
          <ExcelColumn label="GSTIN/UIN No." value="" />
          <ExcelColumn label="Amount" value="" />
          <ExcelColumn label="Type (Dr/Cr)" value="" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  renderDownloadSalesReport(dataset) {
    if (dataset.length === 0) {
      return;
    }
    return (
      <ExcelFile
        filename={`Billing-${moment().format("DD-MM-YYYY")}`}
        element={
          <div
            className="Button Primary-Button"
            style={{
              marginLeft: 20,
              width: 100,
              fontFamily: "'Poppins', sans-serif",
              padding: "0 5px",
            }}
          >
            {" "}
            Download
          </div>
        }
      >
        <ExcelSheet data={dataset} name="billing">
          <ExcelColumn label="ID/ Vch No." value="vch_no" />
          <ExcelColumn label="Vch Type" value="vch_type" />
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="Reference" value="reference" />
          <ExcelColumn label="Debit Ledger" value="debit_ledger" />
          <ExcelColumn label="Credit Ledger" value="credit_ledger" />
          <ExcelColumn label="Amount" value="amount" />
          <ExcelColumn label="Billname" value="bill_name" />
          <ExcelColumn label="Narration" value="narration" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  renderDownloadReceiptsReport(dataset) {
    if (dataset.length === 0) {
      return;
    }
    return (
      <ExcelFile
        filename={`Receipts-${moment().format("DD-MM-YYYY")}`}
        element={
          <div
            className="Button Primary-Button"
            style={{
              marginLeft: 20,
              width: 100,
              fontFamily: "'Poppins', sans-serif",
              padding: "0 5px",
            }}
          >
            {" "}
            Download
          </div>
        }
      >
        <ExcelSheet data={dataset} name="Receipts">
          <ExcelColumn label="Receipt Number" value="receipt_number" />
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="LedgerName" value="ledger_name" />
          <ExcelColumn label="Fee Head / Bill Name" value="bill_name" />
          <ExcelColumn label="Cash/Bank Name" value="bank_name" />
          <ExcelColumn label="Cheque No" value="cheque_number" />
          <ExcelColumn label="Payee Bank Name" value="payee_bank_name" />
          <ExcelColumn label="Amount" value="amount" />
          <ExcelColumn label="Narration" value="narration" />
          <ExcelColumn label="Voucher type" value="vch_type" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  renderNoDataMessage() {
    return (
      <div
        style={{
          textAlign: "center",
          color: StyleConstants.color.darkBlue,
          fontFamily: "'Poppins', sans-serif",
          fontSize: 20,
          margin: 30,
        }}
      >
        Please Fetch Data!
      </div>
    );
  }

  renderScreen() {
    const { showStudentDetails, showSalesReport, showReceiptReport } =
      this.state;
    return (
      <div style={{ padding: "0px 50px 50px 50px" }}>
        {this.renderTabs()}
        {this.renderFilters()}
        {showStudentDetails && this.renderStudentLedger()}
        {showSalesReport && this.renderSalesReport()}
        {showReceiptReport && this.renderReceiptsReport()}
      </div>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          You dont have permission to access to this page{" "}
        </span>
      </div>
    );
  }

  render() {
    const { hasAccess } = this.state;
    const { isLoading } = this.props;
    if (isLoading) {
      return <Loader />;
    }
    return hasAccess ? this.renderScreen() : this.noPermission();
  }
}

Tool.defaultProps = {
  isLoading: false,
  feeAccounts: [],
  accountants: [],
  campuses: [],
  institutesTags: [],
};

Tool.propTypes = {
  isLoading: PropTypes.bool,
  feeAccounts: PropTypes.array,
  campuses: PropTypes.array,
  institutesTags: PropTypes.array,
};

const mapStateToProps = ({ report, home }) => ({
  payments: report.payments,
  isLoading: report.isLoading,
  feeAccounts: report.feeAccounts,
  accountants: report.accountants,
  campuses: report.campuses,
  classrooms: report.classrooms,
  students: report.students,
  daywiseReportData: report.daywiseReportData,
  institutesTracks: home.institutesTracks,
  salesReport: report.salesReport,
  receiptsReport: report.receiptsReport,
  feeAccounts: report.feeAccounts,
});

export default connect(mapStateToProps, {
  resetReport,
  fetchReports,
  getFeeAccounts,
  fetchStudentsData,
  getSalesReport,
  getReceiptsReport,
})(Tool);
